import { render } from "./EventsList.vue?vue&type=template&id=4f19bfc0"
import script from "./EventsList.vue?vue&type=script&lang=js"
export * from "./EventsList.vue?vue&type=script&lang=js"

import "./EventsList.vue?vue&type=style&index=0&id=4f19bfc0&lang=css"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/EventsList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4f19bfc0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4f19bfc0', __exports__)) {
    console.log('reload')
    api.reload('4f19bfc0', __exports__)
  }
  
  module.hot.accept("./EventsList.vue?vue&type=template&id=4f19bfc0", () => {
    console.log('re-render')
    api.rerender('4f19bfc0', render)
  })

}


export default __exports__